import {createReducer} from '@reduxjs/toolkit'
import {Event} from '@wix/ambassador-wix-events-web/types'
import {getScheduleData} from '../actions/schedule'

const initialState: Event = {}

export const event = createReducer(initialState, builder => {
  builder.addCase(getScheduleData.fulfilled, (state, action) => action.payload.event)
})
